var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      !_vm.connectedToOnlineAccounting
        ? _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "darken-1",
                      attrs: { flat: "", dense: "", color: "white" }
                    },
                    [
                      _c("v-toolbar-title", [
                        _vm._v("\n          Quick, Easy Invoicing\n        ")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("div", { staticClass: "px-2 pt-2" }, [
                        _c("p", [
                          _vm._v(
                            "Authorize " +
                              _vm._s(_vm.$t("site-title.brief")) +
                              " to connect to your Online accounting to streamline creating and\n            sending customer invoices and " +
                              _vm._s(_vm.$t("terms.vendor")) +
                              ".  It's fast and easy."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("site-title.brief")) +
                              " Quickbooks Connect or Xero Direct is a marginal monthly fee, but frees up countless hours by\n            creating accurate invoices and bills, providing the " +
                              _vm._s(_vm.$t("terms.bill-of-lading")) +
                              " automatically created for each\n            load, and linking back to the load here on " +
                              _vm._s(_vm.$t("site-title.brief")) +
                              " for further reference."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Click below to get started. You'll be asked to connect " +
                              _vm._s(_vm.$t("site-title.brief")) +
                              " right away."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", "justify-center": "" } },
                        [
                          _c("v-quickbooks-connect-btn", {
                            attrs: {
                              "company-id": _vm.company.id,
                              loading: _vm.connectButtonLoading
                            },
                            on: {
                              connecting: function($event) {
                                _vm.connectButtonLoading = true
                              },
                              connected: _vm.quickbooksConnected
                            }
                          }),
                          _vm._v(" "),
                          _c("v-xero-direct-connect-btn", {
                            attrs: {
                              "company-id": _vm.company.id,
                              connecting: _vm.connectButtonLoading
                            },
                            on: {
                              connecting: function($event) {
                                _vm.connectButtonLoading = true
                              },
                              connected: _vm.xeroConnected
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.isQbConnected
        ? _c("quickbooks-section", { attrs: { company: _vm.company } })
        : _vm.isXroConnected
        ? _c("xero-section", { attrs: { company: _vm.company } })
        : _c("span", [_vm._v("Something is connected. But what?")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-335dae74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335dae74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Sections/InvoicingSection.vue
// module id = null
// module chunks = 